import { Pipe, PipeTransform } from '@angular/core';
//import { Dictionary } from 'async';

@Pipe({
  name: 'abFilterCountries'
})
export class AbFilterCountriesPipe implements PipeTransform {
  transform(arr: any, searchValue: string) {
    if (!searchValue) return arr;

    return arr.filter(
      country =>
        country.value.toLowerCase().match(searchValue.toLowerCase()) !== null
    );
  }
}
